import { AuthProvider } from './lib/AuthContext.jsx';
import DashboardGate from './components/DashboardGate.jsx';

export default function App() {
  return (
    <AuthProvider>
      <DashboardGate />
    </AuthProvider>
  );
}
